<template>
  <div class="tlqn-line-progress-wrapper">
    <div
      class="tlqn-line-progress-block"
      :style="{
        width: `${Math.max(0, Math.min(width, 100))}%`,
        transition: 'all 2s ease-out ' + `${delay}s`,
      }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 40,
    },

    delay: {
      type: Number,
      default: 10,
    },
  },

  data() {
    return {
      width: 0,
    };
  },

  watch: {
    progress: {
      immediate: true,
      handler(p) {
        this.width = p;
      },
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";
.tlqn-line-progress-wrapper {
  width: 100%;
  height: 8px;
  background-color: $tailong-purple;
  border-radius: 8px;
  overflow: hidden;
}
.tlqn-line-progress-block {
  width: 0;
  height: inherit;
  border-radius: inherit;
  background-color: $secondary;
  box-shadow: inset 0px 4px 4px rgba(255, 255, 255, 0.3),
    inset 0px -4px 4px rgba(0, 0, 0, 0.2);
}
</style>
